



























































































import {
  defineComponent,
  ref,
  computed,
  watch,
  useContext,
  onMounted
} from '@nuxtjs/composition-api';
import { useCurrentUser, useHeader } from '@vue-storefront/novulo';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  props: {
    isDropdownOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const context = useContext();

    const isMounted = ref(false);
    onMounted(() => {
      isMounted.value = true;
    });

    const { currentUser } = useCurrentUser();
    const { headerResult } = useHeader();

    const formatUrl = useUrlFormatter();

    const username = computed(() => {
      if (currentUser.value) {
        return (
          currentUser.value.contact.first_name ||
          currentUser.value.contact.company ||
          ''
        );
      }

      return null;
    });

    const iconButtons = (code) => {
      if (!headerResult.value) return [];
      return (
        headerResult.value
          .find((d) => d.code === 'header_icon_buttons')
          ?.elements?.[0]?.urls.find((e) => e.code_english === code) || []
      );
    };

    const handleRedirectToAccount = () => {
      const buttonData = iconButtons('account');
      if (!buttonData?.url) return;
      window.location.href = formatUrl(buttonData.url);
    };

    const loginUrl = formatUrl(context.i18n.t('login_url') as string);
    const registerUrl = formatUrl(context.i18n.t('register_url') as string);

    const HOVER_OPEN_DELAY_MS = 200;
    const OPEN_TO_CLOSE_DEBOUNCE_MS = 200;

    const canCloseDropdown = ref(true);
    watch(
      () => props.isDropdownOpen,
      (isOpen) => {
        if (isOpen) {
          canCloseDropdown.value = false;
          setTimeout(() => {
            canCloseDropdown.value = true;
          }, OPEN_TO_CLOSE_DEBOUNCE_MS);
        }
      }
    );

    const handleCloseDropdown = () => {
      if (!canCloseDropdown.value) return;
      emit('toggleDropdown', false);
    };

    const handleToggleLoginDropdown = () => {
      if (!canCloseDropdown.value) return;
      emit('toggleDropdown');
    };

    let hoverTimeout;
    const handleMouseOverLoginDropdown = () => {
      if (hoverTimeout || props.isDropdownOpen) return;
      hoverTimeout = setTimeout(() => {
        emit('toggleDropdown', true);
      }, HOVER_OPEN_DELAY_MS);
    };

    const handleMouseLeaveLoginDropdown = () => {
      if (!hoverTimeout) return;
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    };

    const clickOutsideConfig = {
      handler: handleCloseDropdown,
      middleware: (event) => {
        const loginDropdowns = Array.from(
          document.querySelectorAll('.login-dropdown')
        );
        return !loginDropdowns.some((dropdown) =>
          dropdown.contains(event.target)
        );
      },
      events: ['click']
    };

    const registerListItems = (
      context.i18n.t('login_dropdown_register_list') as string
    ).split(' * ');

    return {
      isMounted,
      currentUser,
      username,
      iconButtons,
      handleRedirectToAccount,
      handleToggleLoginDropdown,
      handleMouseOverLoginDropdown,
      handleMouseLeaveLoginDropdown,
      clickOutsideConfig,
      registerListItems,
      loginUrl,
      registerUrl
    };
  }
});
